import styled from "styled-components";
import BackButtonComponent from "@/components/BackButton";

// Cast to fix React 17 + @types/react 18 compatibility issue
const BackButton = BackButtonComponent as any;

export const ButtonContainer = styled(BackButton)``;
